import type * as React from 'react';
import { get } from '@Domain/Api';
import assignmentScopePath from '@Application/Ai/AiConfiguration/Assignments/assignmentScopePath';
import modelAssignmentsFetched, {
	type ModelAssignmentsFetchedAction,
	type ModelAssignmentsFetchedPayload,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetched';
import modelAssignmentsFetchFailed, {
	type ModelAssignmentsFetchFailedAction,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetchFailed';
import type FetchModelAssignments from '@Application/Ai/AiConfiguration/Assignments/Queries/FetchModelAssignments';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = ModelAssignmentsFetchedAction | ModelAssignmentsFetchFailedAction;

export default (query: FetchModelAssignments) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<ModelAssignmentsFetchedPayload>(
				`${parameters.api.host}/api/${assignmentScopePath(query.scope)}`,
			);

			const action = modelAssignmentsFetched(payload, query.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = modelAssignmentsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
